function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGenericUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      mixBlendMode: "normal",
      fill: "#020000",
      fillOpacity: 0.06532663,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.32941145,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    d: "M10.81 31.135A16 16 0 0 1 .706 11.303 16 16 0 0 1 20.199.561a16 16 0 0 1 11.368 19.137 16 16 0 0 1-18.759 11.98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 5c-3.855 0-7 3.145-7 7 0 2.41 1.23 4.55 3.094 5.813C8.527 19.343 6 22.883 6 27h2c0-4.43 3.57-8 8-8s8 3.57 8 8h2c0-4.117-2.527-7.656-6.094-9.188A7.024 7.024 0 0 0 23 12c0-3.855-3.145-7-7-7Zm0 2c2.773 0 5 2.227 5 5s-2.227 5-5 5-5-2.227-5-5 2.227-5 5-5z",
    style: {
      fill: "#000",
      fillOpacity: 0.47236185
    },
    transform: "matrix(1.05899 0 0 1.0927 -.944 -1.483)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericUser);
export default __webpack_public_path__ + "static/media/generic-user.56845f21c7449933c22dc901b4029d21.svg";
export { ForwardRef as ReactComponent };